import Base from './Base'

class CompanyService extends Base {
  search(postData) {
    return this.post('company/search_company', postData)
  }

  searchTme(postData) {
    return this.post('tme_company/search_company', postData)
  }
}

export default new CompanyService()
